import { PieChart, type PieChartCell } from '@mantine/charts';
import { Legend } from 'recharts';

import { getSeriesColor } from '#core/lib/formatters/colors.ts';
import { makeFieldFormatter } from '#core/lib/formatters/number-decimals.ts';

import classes from '../Chart.module.css';
import type { ChartRendererProps } from '../types.ts';

/**
 * Renders pie chart.
 */
export function PieChartRenderer({ config, width, height }: ChartRendererProps) {
  return (
    <PieChart
      className={classes.chart}
      data={config.data.map(
        (row, i) =>
          ({
            key: `${row[config.xAxis]}-${i}`,
            name: String(row[config.xAxis] ?? `Item ${i + 1}`),
            value: typeof row[config.yAxis] === 'number' ? (row[config.yAxis] as number) : 0,
            color: getSeriesColor(i),
          }) satisfies PieChartCell,
      )}
      size={Math.min(width, height) * 0.5}
      valueFormatter={makeFieldFormatter(config.data, config.yAxis)}
      withLabels
      withTooltip
    >
      <Legend verticalAlign="bottom" />
    </PieChart>
  );
}
